import api from '@/services/api/api';

const defaultOptions = {
  staleTime: Infinity,
  refetchOnFocus: false,
  refetchOnReconnect: false,
};

export const useGenocide = (
  options = {
    staleTime: Infinity,
    refetchOnFocus: false,
    refetchOnReconnect: false,
  },
) => {
  const genocide = useQuery(
    ['genocide'],
    async () => {
      const { data } = await api.collections.getGenocideHighlight();
      return data;
    },
    { ...defaultOptions, ...options, select: ({ highlight }) => highlight },
  );

  onServerPrefetch(async () => {
    await genocide.suspense();
  });

  return {
    genocide,
  };
};
